var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 81,
    viewBox: "0 0 77 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.02656e-06H31.108V19.7863L9.548 81H0V2.02656e-06ZM45.892 2.02656e-06H77V19.7863L55.44 81H45.892V2.02656e-06Z",
    fill: "#C71B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndQuote);
export default __webpack_public_path__ + "static/media/EndQuote.97231a84e5e351f896e8f264e75e7e32.svg";
export { ForwardRef as ReactComponent };